// see http://vuejs-templates.github.io/webpack for documentation.
const path = require('path');
const langConfig = require('./lang')
const locale = langConfig.locale;
const subDir = "";
const appContextConfig = require('./app-context');
const appOnly = appContextConfig.apponly;

const folderName = appOnly == "true" ? "/release/app/" :  "/release/" + locale + '/';





module.exports = {
  build: {
    env: require('./prod.env'),
    index: path.resolve(__dirname, "../" + folderName + "index.html"),
    assetsRoot: path.resolve(__dirname, "../" +  folderName),
    assetsSubDirectory: 'static',
    assetsPublicPath: appOnly == "true" ? "/app/" : subDir + "/" +  locale + "/",
    productionSourceMap: true,
    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: true,
    productionGzipExtensions: ['js', 'css'],
    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  },
  dev: {
    env: require('./dev.env'),
    port: 8080,
    autoOpenBrowser: true,
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {},
    // CSS Sourcemaps off by default because relative paths are "buggy"
    // with this option, according to the CSS-Loader README
    // (https://github.com/webpack/css-loader#sourcemaps)
    // In our experience, they generally work as expected,
    // just be aware of this issue when enabling this option.
    cssSourceMap: false
  }
};



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = 1304
// module chunks = 1